import { render, staticRenderFns } from "./ImagePanel.vue?vue&type=template&id=608edad0"
import script from "./ImagePanel.vue?vue&type=script&lang=js"
export * from "./ImagePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports